import { FC, useEffect, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { Redirect } from 'react-router-dom';
import Swal from 'sweetalert2';
import ContainerBox from '../../../components/ContainerBox';
import { EyeTwoTone, EyeInvisibleOutlined, LockOutlined } from '@ant-design/icons';
import { Titulo } from '../style';
import api from '../../../service/api';
import { SKW_AUTH, SKW_PREFIX } from '../../../utils/constants';

export interface Rules {
  required: boolean;
  message: string;
}

function CONFIRM_PASSWORD_VALIDATOR(field: any) {
  return [
    ({ getFieldValue }: any) => ({
      validator(rule: any, value: any) {
        if (!value || getFieldValue(field) === value) {
          return Promise.resolve();
        }
        return Promise.reject('As senhas não conferem!');
      },
    }),
  ];
}

const ResetPassword: FC<any> = (props: any) => {
  const token = new URLSearchParams(props.location.search).get('token');
  const [login, setLogin] = useState<boolean>(false);

  const onFinish = (formData: any) => {
    try {
      api.post(`call?serviceName=${SKW_PREFIX}alterarSenha&accessKey=${SKW_AUTH}&token=${token}`, {
        senha: formData?.senha,
      });
      Swal.fire({
        title: 'Nova senha cadastrada com sucesso!',
        html: '',
        icon: 'success',
        timer: 1500,
      });
      setTimeout(() => {
        setLogin(true);
      }, 1500);
    } catch (err: any) {
      Swal.fire({
        title:
          'Por motivos de segurança, não foi possível cadastrar uma nova senha, entre em contato com o suporte!',
        html: '',
        icon: 'error',
        timer: 5000,
        showConfirmButton: true,
      });
    }
  };
  const passwordRules: Rules = {
    required: true,
    message: 'Por favor informe uma nova senha!',
  };
  const confirmPasswordRules: Rules = {
    required: true,
    message: 'Por favor confirme sua senha!',
  };

  useEffect(() => {
    if (!token) setLogin(true);
  }, [token]);

  return (
    <ContainerBox>
      <Titulo>
        <LockOutlined /> Nova Senha
      </Titulo>
      <Form name="basic" initialValues={{ remember: true }} onFinish={onFinish} layout="vertical">
        <Form.Item name="senha" rules={[passwordRules]}>
          <Input.Password
            placeholder="Digite sua nova senha"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item
          name="confirmacaoSenha"
          rules={[confirmPasswordRules, ...CONFIRM_PASSWORD_VALIDATOR('senha')]}
        >
          <Input.Password
            placeholder="Confirme sua nova senha"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item>
          <Button htmlType="submit" block type="primary">
            Redefinir senha
          </Button>
        </Form.Item>
      </Form>
      {login && <Redirect to="/login" />}
    </ContainerBox>
  );
};

export default ResetPassword;
